import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DonerType, IDoner } from '../../../../../../shared/schemas/donersSchema';
import { firstValueFrom, lastValueFrom } from 'rxjs';
import { httpOptions } from '../../../services/login.service';
import { environment } from '../../../../environments/environments';

@Injectable({
  providedIn: 'root',
})
export class DonersService {
  private API_URL = environment.API_URL;
  constructor(private http: HttpClient) {}

  async getDoners(): Promise<DonerType[]> {
    return lastValueFrom(this.http.get<DonerType[]>(`${this.API_URL}/doners`));
  }

  async addDoner(donerObj: IDoner): Promise<DonerType> {
    return firstValueFrom(
      this.http.post<DonerType>(`${this.API_URL}/doners`, donerObj, httpOptions),
    );
  }
}
